module.exports = __webpack_public_path__ + "img/default-flag-code.13f75969.svg";